import { Component, Input } from '@angular/core';
import { Tile } from '@app/models/content';
import {TileContext, TileFormat} from '@app/shared/enums';

@Component({
  selector: 'app-tile-video-parent',
  templateUrl: './tile-video-parent.component.html',
  styleUrls: ['./tile-video-parent.component.scss']
})
export class TileVideoParentComponent {

  @Input() tile: Tile;
  @Input() format: TileFormat;
  @Input() context: TileContext;

  constructor() { }
}
